import type { AppState } from '@auth0/auth0-react';
import { Auth0Provider } from '@auth0/auth0-react';
import type { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { AUTH_0_SCOPE, OAUTH_ROUTE_PREFIX, PATHNAMES } from '../constants/constants';

const domain = import.meta.env.VITE_APP_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_APP_AUTH0_CLIENT_ID;
const audience = import.meta.env.VITE_AUTH_NAMESPACE;
const redirectUri = window.location.origin;
interface Auth0ProviderWithHistoryProps {
  children: ReactNode;
}

const Auth0ProviderWithHistory: FC<Auth0ProviderWithHistoryProps> = ({ children }) => {
  'use memo';
  const navigate = useNavigate();

  const onRedirectCallback = async (appState: AppState | undefined) => {
    const returnTo = appState?.returnTo;
    const destination = returnTo && !returnTo.startsWith(PATHNAMES.authLogin) ? returnTo : PATHNAMES.main;
    navigate(destination);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience,
        redirect_uri: redirectUri,
        scope: AUTH_0_SCOPE,
      }}
      onRedirectCallback={onRedirectCallback}
      skipRedirectCallback={window.location.pathname.startsWith(OAUTH_ROUTE_PREFIX)}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
